<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="300px"
    @keydown.esc="cancel()"
  >
    <v-system-bar
      dark
      dense
      :color="titleBackground"
    >
      <span class="white--text">{{ title }}</span>
    </v-system-bar>

    <v-card>
      <v-card-text
        style="font-size:15px;"
        v-show="!!message"
        v-html="message"
        class="pa-3"
      ></v-card-text>

      <v-card-actions v-if="versione==1">
        <v-spacer></v-spacer>
        <v-btn
          @click.native="agree()"
          outline
        >Si</v-btn>
        <v-btn
          @click.native="cancel()"
          outline
        >No</v-btn>
      </v-card-actions>
      <v-card-actions v-else-if="versione==2">
        <v-spacer></v-spacer>
        <v-btn
          @click.native="agree()"
          outlined
        >Si</v-btn>
        <v-btn
          @click.native="cancel()"
          outlined
        >No</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { EventBus } from "./confirmEventBus";

export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      titleBackground: "",
    };
  },
  methods: {
    open(title, message) {
      this.dialog = true;
      this.title = title;
      this.message = message;
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },

    handleConfirm(res, rej, title, msg) {
      this.resolve = res;
      this.rej = rej;

      this.open(title, msg);
    },
  },

  beforeMount() {
    // Impostazioni
    this.titleBackground = this.$confirmOptions.titleBackground;

    EventBus.$on("ConfirmOpen", this.handleConfirm);
  },

  beforeDestroy() {
    EventBus.$off("ConfirmOpen", this.handleConfirm);
  },

  computed: {
    versione() {
      return this.$confirmOptions.version;
    },
  },
};
</script>